import React, { useEffect, useState } from "react";
import LottieView from "lottie-react-native";
import { ThemedText, ThemedView } from "@app/theme";
import axios from "axios";
import { endpoints } from "@app/api/apis";
import { LENDER_DISPLAY_NAME_MAP } from "@app/constants/platformPartners";
import ROUTE from "@app/navigationApp/routes";
import fetchUserDetails from "@app/helper/fetchUserInfo";
import { LENDER_ID } from "@app/types/regix";
import { updateLMSUserDashboard } from "@app/store/slices/commonSlice";
import { useAppDispatch, useAppSelector } from "@app/store/hooks";
import { updateBFLCheck } from "@app/store/slices/commonSlice";
import useSingleRemoteConfig from "@app/hooks/useSingleRemoteConfig";
const loading = require("../../../assets/lottie/account_switch_loader.json")
const success = require("../../../assets/lottie/account_switch_success.json")
const failure = require("../../../assets/lottie/account_switch_failure.json")


const ElevateSwitching = ({navigation,route}) => {
    const [lottie, setLottie] = useState<any>(loading);
    const [title, setTitle] = useState<string>("Switching loan accounts...");


    const isBFLFirebase = useAppSelector((state) => state.firebaseParams?.bfl_shutdown);
    const isBFLfromFirebaseBoolean = isBFLFirebase && isBFLFirebase === 'true';

    const dispatch = useAppDispatch()

    useEffect(()=>{
        const payload = {
            accountId: route.params.accountId,
            updatedCreditId: route.params.targetCreditId
        }
        axios.post(endpoints.switchCredit,payload,{handleFromMF: true })
        .then((res)=>{
            setLottie(success);
            dispatch(updateBFLCheck({ isBFLLoan: res?.data?.lendingPartnerId?.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase() && isBFLfromFirebaseBoolean }));
            setTitle("Switched to " + (res.data?.lendingPartnerId ? LENDER_DISPLAY_NAME_MAP[res.data?.lendingPartnerId] : "loan account"));
        })
        .catch((err)=>{
            console.log('switchCredit',err);
            setLottie(failure);
            setTitle("Failed to switch loan accounts");

        }).finally(()=>{
            fetchUserDetails()
            dispatch(updateLMSUserDashboard({isLMSUserDashboard:true}))
            setTimeout(()=>{
                   navigation.reset({
                            index: 0,
                            routes: [{ name: 'HOME' }]
                        })
            },2000)
        })
    },[])
    
        return (
            <ThemedView flex={1} justifyContent="center" alignItems="center" backgroundColor="bg-fill-primary">
                <LottieView
                    source={lottie}
                    style={{ width: 150, height: 150 }}
                    autoPlay={true}
                    loop={true}
                />
                <ThemedText color="text-primary" variant="b3s" >{title}</ThemedText>
            </ThemedView>
        )
    };


export default ElevateSwitching
